import { useParams } from 'react-router-dom';

export const useSubaPlansDetailRouteParams = () => {
  return useParams<{
    accountId: string;
    activeTab?: string;
    planId: string;
  }>();
};
